module.exports = __webpack_public_path__ + "img/20200514_140611.809ff33d.jpg";